import React from 'react';
import { classNames } from '../helpers/classes';

interface ButtonProps {
  type?: 'submit' | 'button' | 'reset' | undefined;
  text: string;
  onClick?: () => void;
  disabled?: boolean;
  ref?: any;
  extreme?: boolean;
}

const BlueButtonBig: React.FC<ButtonProps> = ({
  type = 'submit',
  text,
  onClick,
  extreme = false,
  ...props
}: ButtonProps) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={classNames(
        extreme ? 'bg-orange' : 'bg-primary',
        'disabled:opacity-50 w-full text-center text-black font-bold px-3 py-4 rounded-sm cursor-pointer'
      )}
      {...props}
    >
      <span>{text}</span>
    </button>
  );
};

export default BlueButtonBig;
